import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { LocationRegionsDto } from './dtos'
import type { GetRegionsParams } from './types'

const URL = '/location/regions/'

export const getRegions: AblePaginatedResponseFn<GetRegionsParams, LocationRegionsDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
